import React from 'react';
import { Tag, Tooltip } from 'antd';
import moment from 'moment';
import { InvitationStatus } from '../../interfaces/team';

interface InvitationStatusBadgeProps {
  status: InvitationStatus | 'active';
  expiresAt?: string;
}

const InvitationStatusBadge: React.FC<InvitationStatusBadgeProps> = ({
  status,
  expiresAt,
}) => {
  if (status === 'active') {
    return <Tag color="green">Active</Tag>;
  }

  if (status === InvitationStatus.PENDING) {
    const isExpired = expiresAt && moment(expiresAt).isBefore(moment());
    const expiryText = expiresAt
      ? isExpired
        ? 'Expired'
        : `Expires ${moment(expiresAt).fromNow()}`
      : '';

    return (
      <Tooltip title={expiryText}>
        <Tag color={isExpired ? 'red' : 'orange'}>
          {isExpired ? 'Expired' : 'Invited'}
        </Tag>
      </Tooltip>
    );
  }

  if (status === InvitationStatus.ACCEPTED) {
    return <Tag color="green">Accepted</Tag>;
  }

  if (status === InvitationStatus.EXPIRED) {
    return <Tag color="red">Expired</Tag>;
  }

  if (status === InvitationStatus.WITHDRAWN) {
    return <Tag color="default">Withdrawn</Tag>;
  }

  return null;
};

export default InvitationStatusBadge;
